// extracted by mini-css-extract-plugin
export default {"label":"acceptAnnouncement_label__YmzAQ","btnContainer":"acceptAnnouncement_btnContainer__oA4hm","error":"acceptAnnouncement_error__o53iK"};